/* eslint-disable semi */
// @flow

import React, { useState } from 'react';
import classNames from 'classnames';
import { log } from '../../utils/jsUtils';
import { useStore } from '../../store';

import Button from '@mui/material/Button';
import ToggleButton from '@mui/lab/ToggleButton';
import Input from '@mui/material/Input';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import BroadcastIcon from '@mui/icons-material/TextsmsOutlined';

import withStyles from '../../utils/withStyles';
import styles from './Styles/AddPropertyDialog.Style';

type Props = {
  classes: Object,
  
  setOpen: Function,
  open: boolean,
  triggerAction: Function
}

const AddProperty = (props: Props) => {
  const {
    classes,
    setOpen,
    open,
    triggerAction
  } = props;
  const [property, setProperty] = useState('');

  const [store] = useStore();
  const {
    i18n
  } = store;

  return (
    <Dialog
      aria-labelledby='form-add-property'
      onClose={() => setOpen(false)}
      open={open}
    >
      <form
        autoComplete='off'
        className={classes.dialogFormCtr}
        onSubmit={(e) => { e.preventDefault(); triggerAction(property); setOpen(false); }}
        noValidate>
          <DialogTitle id='form-dialog-title'>
          {`Add a ${i18n.t('property')}`}
          </DialogTitle>
          <DialogContent className={classNames(classes.grow, classes.flexContainer)}>
            <DialogContentText className={classNames(classes.grow)}>
              {`Description of the ${i18n.t('property')}, as it will appear in the ${i18n.t('feed')}.`}
            </DialogContentText>
            <Input
                autoFocus
                fullWidth
                id='broadcastIssue'
                label={`${i18n.t('Property')}`}
                margin='dense'
                onChange={(e) => setProperty(e.target.value)}
                type='text'
                value={property}
            />
          </DialogContent>
          <DialogActions>
            <Button color='primary'
              onClick={() => setOpen(false)}
            >
              {'Cancel'}
              </Button>
            <Button 
              color='primary'
              onClick={() => { triggerAction(property); setOpen(false); }}
              variant='contained'
            >
              {'Add'}
              </Button>
          </DialogActions>
      </form>
    </Dialog>
  );
}

export default withStyles(styles)(AddProperty);